import React, { Component } from 'react';
import TextField from '@mui/material/TextField';

export default class DerivInput extends Component {

    handleChange = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event.target.value?.replaceAll(' ', '').toUpperCase());
        }
    };

    render() {
        return (
            <TextField
                {...this.props.props}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe a derivação" : null}
                size="small"
                variant="outlined"
                name="numemp"
                label={'Derivação' + (this.props.required ? '*' : '')}
                value={this.props.value}
                onChange={this.handleChange}
            />
        );
    }
}